import { useEffect, useRef } from 'react';

/**
 * Hook ktery si pamatuje predchozi hodnotu s generickym typem
 * @param value hodnota ktera se ma zapamatovat
 * @returns vraci zapamatovanou hodnotu
 */
export function usePrevious<T>(value: T) {
    const ref = useRef<T | null>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
